<template>
  <v-list-item
    key="itemMenu-polyOffice-import"
    data-locator="poly-import-menu-item"
    @click="handleClick"
  >
    <v-list-item-title>
      <div class="d-flex align-center">
        <v-img src="@/assets/img/LexisPoly.svg"
               max-height="18"
               max-width="18"
               class="mr-2"
        />
        <span class="text-text-secondary">{{ $t('common.polyOffice.PolyOfficeListItemImport.importFiles') }}</span>
      </div>
    </v-list-item-title>
  </v-list-item>
</template>

<script>

export default {
  name: 'PolyOfficeListItemImport',
  methods: {
    handleClick () {
      this.$emit('polyOfficeOpenDialog')
    },
  },
}
</script>
